import { useEffect, useState } from 'react';

import { get } from '../../api';
import { useGlobalStore } from '../state/globalStore';
import { ENTITY_TYPE } from '../utils/constants';
import { getEntityCookiePassword } from '../utils/helper';
import { EVENT_STATUS_TYPE } from '../utils/types';

/**
 * Returns the following values
 * 1. null -> if the event has not went live yet.
 * 2. started -> event is either live or have went live at-least once but is not completed yet.
 * 3. ended -> event has been completed/ended. this happens when the user clicks on complete event button.
 */
export const useEntityLiveStatus = (hasNewLeadCaptureFlow = false) => {
  const entityId = useGlobalStore((store) => store.apiEntityId);
  const entityType = useGlobalStore((store) => store.entityType);
  const [status, setStatus] = useState<EVENT_STATUS_TYPE>(null);

  useEffect(() => {
    const shouldFetchData = entityId && entityType && hasNewLeadCaptureFlow && status !== 'ended';
    if (!shouldFetchData) {
      return;
    }

    const entityPassword = getEntityCookiePassword(entityId, entityType);

    let refreshInterval: number;

    const getLiveStatusDataEvent = async () => {
      try {
        if (entityType === ENTITY_TYPE.EVENT) {
          const response = await get(
            `/live_events/${entityId}?fields=status&password=${entityPassword}`,
          );
          const status = response['status'] as EVENT_STATUS_TYPE;
          useGlobalStore.setState({
            entity: { ...useGlobalStore.getState().entity, status: status },
          });
          setStatus(status);
        }
      } catch (error) {
        return false;
      }
    };

    const getLiveStatusData = () => {
      switch (entityType) {
        case ENTITY_TYPE.EVENT:
          getLiveStatusDataEvent();
          break;
      }
    };

    if (entityType === ENTITY_TYPE.EVENT) {
      refreshInterval = setInterval(() => {
        getLiveStatusData();
      }, 10000);
    }

    getLiveStatusData();

    return () => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, entityId, hasNewLeadCaptureFlow]);

  return status;
};
